import { Link } from "react-router-dom";

export function LegalLayout({ title, lastUpdate = "Mayo 2026", children }) {
  return (
    <div className="min-h-screen bg-[#F8F7F2]">
      <header className="border-b border-border bg-white">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="font-display text-lg font-semibold">Dr. Dimy Laguerre</Link>
          <Link to="/" className="text-sm text-primary hover:underline">← Volver</Link>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="mb-8">
          <h1 className="font-display text-3xl sm:text-4xl tracking-tight">{title}</h1>
          <div className="text-sm text-muted-foreground mt-2">Última actualización: {lastUpdate}</div>
        </div>
        <article className="bg-white border border-border rounded-2xl p-8 lg:p-10 prose prose-sm max-w-none prose-headings:font-display prose-headings:tracking-tight">
          {children}
        </article>
        <div className="mt-8 text-xs text-muted-foreground border-t pt-6">
          <p>
            <strong>Importante:</strong> Este texto ha sido redactado conforme a la normativa española y europea
            vigente (RGPD 2016/679, LOPDGDD 3/2018, Ley 41/2002, LSSICE 34/2002). Se recomienda revisión por un
            abogado especializado antes de publicación oficial.
          </p>
        </div>
      </main>
    </div>
  );
}

export const CLINIC = {
  name: "Dr. Dimy Laguerre",
  colegiado: "41/4119650",
  nif: "Y6766300J",
  address: "Avenida del Hermanamiento 10, 41820 Carrión de los Céspedes, Sevilla",
  email: "djimlag25@gmail.com",
  phone: "+34 742 08 65 96",
  domain: "drdimylaguerre.com",
};
